import request, { deAxios } from '@/utils/request'
import { Content } from '@/types'
import get from 'lodash/get'

const apiFactory = () => {
  const getCategories: Content.API.GetCategories = ({ lang }) => {
    return request({
      method: 'get',
      url: '/cadence-service/content/category',
      params: {
        lang
      }
    })
      .then(deAxios)
  }
  const getHtmlContent: Content.API.GetHtmlContent = (url) => {
    return fetch(new URL(url).href)
      .then(data => data.text())
      .catch(error => {
        console.warn(error.message)
        return ''
      })
  }
  const getContentItemById: Content.API.GetContentItemById = ({ contentId, lang }) => {
    return request({
      method: 'get',
      url: `/cadence-service/content/${contentId}`,
      params: {
        lang
      }
    })
      .then(deAxios)
  }
  const contentByCategory: Content.API.ContentByCategory = ({ categoryId, lang }) => {
    return request({
      method: 'get',
      url: '/cadence-service/content',
      params: {
        categoryId,
        lang
      }
    })
      .then(deAxios)
  }
  const searchContent: Content.API.SearchContent = ({ q, lang }) => {
    return request({
      method: 'get',
      url: '/cadence-service/content/search',
      params: {
        lang,
        q,
        limit: 1000
      }
    })
      .then(data => get(data, 'data.items', []))
  }

  const getBookmarks: Content.API.GetBookmarks = ({ lang }) => {
    return request({
      method: 'get',
      url: '/cadence-service/bookmark/list',
      params: {
        lang
      }
    })
      .then(deAxios)
  }

  const createBookmark: Content.API.CreateBookmark = ({ contentId, lang }) => {
    return request({
      method: 'post',
      url: '/cadence-service/bookmark/create',
      data: {
        contentId
      },
      params: {
        lang
      }
    })
      .then(deAxios)
  }
  const removeBookmark: Content.API.RemoveBookmark = ({ contentId, lang }) => {
    return request({
      method: 'delete',
      url: `/cadence-service/bookmark/remove/${contentId}`,
      params: {
        lang
      }
    })
      .then(deAxios)
  }

  return {
    getCategories,
    getHtmlContent,
    contentByCategory,
    getContentItemById,
    searchContent,
    getBookmarks,
    createBookmark,
    removeBookmark
  }
}

export default apiFactory
